module.exports = __webpack_public_path__ + "img/pencil.98d42882.svg";